import { ref } from '@vue/composition-api'
import { isNavGroupActive } from '@core/layouts/utils'
import router from '@/router'

export default function useHorizontalNavMenuHeaderGroup(item) {
  // ------------------------------------------------
  // isOpen
  // ------------------------------------------------
  const isOpen = ref(false)

  const updateGroupOpen = val => {
    // eslint-disable-next-line no-use-before-define
    isOpen.value = val
  }

  // ------------------------------------------------
  // isActive
  // ------------------------------------------------
  const isActive = ref(false)

  const updateIsActive = () => {
    // isActive.value = isNavGroupActive(item.children)
    isActive.value = item.children.map(child => String(child.type || child.id)).includes(String(router.currentRoute.query?.type)) 
  }

  return {
    isOpen,
    isActive,
    updateGroupOpen,
    updateIsActive,
  }
}
